import React, { Component } from 'react'
import { Alert } from 'react-bootstrap'

export default class AlertsLJ extends Component {

	constructor(props){
		super(props);
	}

  render () {
		const { message, type, visible, onClearAlert } = this.props
		if(!visible) {
			return null
		}
    return (
			<Alert bsStyle={type} onDismiss={() => {
				this.props.onClearAlert()
			}}>
				{message}
			</Alert>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/AlertLJ/index.js